// extracted by mini-css-extract-plugin
export default {"wrapper":"TeaseVideo_wrapper__JcOv2","player":"TeaseVideo_player__JlrBa","wave":"TeaseVideo_wave__itfU2"};